/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Cut_BodyInputs */

const en_for_whom_cut_body = /** @type {(inputs: For_Whom_Cut_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your dietician sets the target and you take a photo of your plate. Calories and macros count themselves, next to what is left for today.`)
};

const pl_for_whom_cut_body = /** @type {(inputs: For_Whom_Cut_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dietetyk ustawia cel, a Ty robisz zdjęcie talerza. Kalorie i makro liczą się same, obok tego, ile zostało na dziś.`)
};

/**
* | output |
* | --- |
* | "Your dietician sets the target and you take a photo of your plate. Calories and macros count themselves, next to what is left for today." |
*
* @param {For_Whom_Cut_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_cut_body = /** @type {((inputs?: For_Whom_Cut_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Cut_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_cut_body(inputs)
	return en_for_whom_cut_body(inputs)
});